import { AxiosError } from 'axios';

export const isAxiosErrorGuard = (error: any): error is AxiosError => {
  if (error.isAxiosError) {
    return true;
  }
  return false;
};
